import React from 'react';
import { Alert, AlertDescription, AlertIcon, AlertProps, AlertTitle, Box, Flex, Link, Text } from '@chakra-ui/react';
import { MegaphoneIcon, WarningThin, CheckmarkThin } from '../../Icons';

const icons = {
  neutral: MegaphoneIcon,
  positive: CheckmarkThin,
  negative: WarningThin,
};

export type AlertBoxProps = {
  variant: 'neutral' | 'positive' | 'negative';
  title?: string;
  showIcon?: boolean;
  description?: string | JSX.Element;
} & AlertProps;

const AlertBox = ({ variant, title, showIcon, description, ...props }: AlertBoxProps): JSX.Element => {
  const Icon = showIcon && icons[variant];
  return (
    <Alert variant={variant} {...props}>
      {showIcon && Icon && <AlertIcon as={Icon} color="black" />}
      <Flex flexDirection="column">
        {title && <AlertTitle mr={2}>{title}</AlertTitle>}
        {description && <AlertDescription mr={2}>{description}</AlertDescription>}
      </Flex>
    </Alert>
  );
};

export default AlertBox;
